<template>
    <v-container class="py-0">
        <v-row>
            <v-col cols="12">
                <!--v-switch v-model="twoColors" :disabled="optionsOff" inset label="Два цвета" color="success" hide-details class="mt-0"></v-switch-->
            </v-col>
            <v-col cols="4" data-test-id="diskColor">
                <v-select
                        v-model="firstColor"
                        :items="colorsList"
                        item-text="name"
                        label="Цвет"
                        color="blue-grey darken-2"
                        dense
                        :rules="nameRules"
                        outlined
                >
                    <template v-slot:item="{ item }">
                      <div :data-test-id="`diskColor-${item.id}`">
                        {{ item.name }}
                      </div>
                  </template>
                </v-select>
            </v-col>
            <v-col cols="4" data-test-id="diskVarnish">
                <v-select
                        v-model="firstVarnish"
                        :items="varnishList"
                        item-text="name"
                        label="Лак"
                        color="blue-grey darken-2"
                        dense
                        :rules="nameRules"
                        outlined
                >
                  <template v-slot:item="{ item }">
                    <div :data-test-id="`diskVarnish-${item.id}`">
                      {{ item.name }}
                    </div>
                  </template>
                </v-select>
            </v-col>
            <v-col v-if="twoColors && !optionsOff" cols="12" class="pa-0 ma-0"></v-col>
            <v-col v-if="twoColors && !optionsOff" cols="4" class="py-0">
                <v-select
                        v-model="secondColor"
                        :items="colorsList"
                        item-text="name"
                        label="Цвет 2"
                        color="blue-grey darken-2"
                        dense
                        :rules="nameRules"
                        outlined
                ></v-select>
            </v-col>
            <v-col v-if="twoColors && !optionsOff" cols="4" class="py-0">
                <v-select
                        v-model="secondVarnish"
                        :items="varnishList"
                        item-text="name"
                        label="Лак 2"
                        color="blue-grey darken-2"
                        dense
                        :rules="nameRules"
                        outlined
                ></v-select>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    export default {
        name: 'chooseColor',
        props: ['side', 'paintType'],
        computed: {
            optionsOff(){
                return this.paintType === 3
            },
            colorsList (){
                return this.$store.state.paint.colors.filter(x => x.type === this.paintType + 1)
            },
            varnishList (){
                // todo когда добавиться поле в лаки как в цвет сделать таже как с цветом
                return this.paintType === 3?this.$store.state.paint.varnishesT3:this.$store.state.paint.varnishes
            },
            firstColor: {
                get() {
                    return this.$store.state[this.source].wheels[this.side].data.firstColor
                },
                set(value) {
                    this.$store.commit(this.source+'/setPlus', { side: this.side, value , item:'firstColor'})
                }
            },
            firstVarnish: {
                get() {
                    return this.$store.state[this.source].wheels[this.side].data.firstVarnish
                },
                set(value) {
                    this.$store.commit(this.source+'/setPlus', { side: this.side, value , item:'firstVarnish'})
                }
            },
            secondColor: {
                get() {
                    return this.$store.state[this.source].wheels[this.side].data.secondColor
                },
                set(value) {
                    this.$store.commit(this.source+'/setPlus', { side: this.side, value , item:'secondColor'})
                }
            },
            secondVarnish: {
                get() {
                    return this.$store.state[this.source].wheels[this.side].data.secondVarnish
                },
                set(value) {
                    this.$store.commit(this.source+'/setPlus', { side: this.side, value , item:'secondVarnish'})
                }
            },
            twoColors() {
                return this.$store.state[this.source].wheels[this.side].data.options[2]
            },
        },
        data() {
            return {
                nameRules: [
                    v => !!v || 'необходимо заполнить',
                ],
                source: 'paint',
            }
        }
    }
</script>
<style lang="scss">
    .addpricetext {
        color: forestgreen;
        font-weight: bold;
        padding-left: 15px;
    }
    .border {
        border-radius: 4px;
        border: thin solid rgba(0,0,0,.12);
    }
    .primary_bg_color {
        background-color: #FFFEEE !important;
    }
    .primary_bg_color .active {
        background-color: #FFFBCD !important;
    }
    .change_disk.v-btn-toggle .v-btn{
        height: 51px !important;
        width: 80px !important;
    }
    .change_disk.v-btn-toggle{
        height: 51px !important;
        width: 80px !important;
    }
    .tabs_icons_big {
        width: 40px;
        height: 40px;
    }
</style>
